import { render, staticRenderFns } from "./BasicEduSolution.vue?vue&type=template&id=1b42e162"
import script from "./BasicEduSolution.vue?vue&type=script&lang=js"
export * from "./BasicEduSolution.vue?vue&type=script&lang=js"
import style0 from "./BasicEduSolution.vue?vue&type=style&index=0&id=1b42e162&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports